/* eslint-disable */

/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Drivers Portal (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Form, Input, Pagination, Select, Spin, Table, Tag, notification } from 'antd';
import React, { useEffect, useState } from 'react';

import { _get_all_payments } from "common/axios_services";
import moment from "moment";
import { NumericFormat } from "react-number-format";

function Payments() {
    const [form] = Form.useForm();
    const [page, setPage] = useState(1);
    const [page_size, setPage_size] = useState(10);
    const [total_wallettrans, setTotal_wallettrans] = useState(0);
    const [spinnerLoading, setSpinnerLoading] = useState(true);
    const [allPayments, setAllPayments] = useState([]);
    const [query, setQuery] = useState('');
    const [fetchingData, setFetchingData] = useState(true);
    const [filterDate, setFilterDate] = useState("");
    const [selectedAccountType, setSelectedAccountType] = useState("");
    const [selectedPaymentType, setSelectedPaymentType] = useState("");
    const [filterToDate, setFilterToDate] = useState(moment().format('YYYY-MM-DD'));

    const jwt = localStorage.konnect_admin_token;

    const openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: '',
            placement: 'bottomRight',
            description:
                message,
        });
    };


    if (!jwt) {
        openNotificationWithIcon('error', 'Unauthorized')
        return navigate('/')
    }

    const getPayments = async () => {
        try {
            const fetchAllPayments = await _get_all_payments({ page, page_size })
            setSpinnerLoading(false)
            setAllPayments(fetchAllPayments.data.data);
            setTotal_wallettrans(fetchAllPayments.data.meta.total)
        } catch (err) {
            setSpinnerLoading(false)
            setFetchingData(false);
            if (err.response) {
                if (err.response.data.message === "Unauthorized") {
                    window.location.reload()
                    navigate('/')
                    openNotificationWithIcon('error', err.response.data.message);
                } else {
                    openNotificationWithIcon('error', err.response.data.message);
                }
            } else {
                openNotificationWithIcon('error', err.message);
            }
        }
    }
    useEffect(() => {
        getPayments()
    }, [page, page_size])

    // Functions to handle
    const change_page = (selected_page, pageSize) => {
        setPage(selected_page);
        setPage_size(pageSize);
    }

    let data = allPayments.map((trans, index) => {
        return {
            key: index,
            name: <span className="d-flex flex-column"><span style={{ textTransform: "capitalize" }}>{trans.user.first_name + ' ' + trans.user.last_name}</span><p style={{ color: "#6e7a75" }}>{trans.user.email}</p></span>,
            date: trans.created_at.split('T')[0],
            transRef: trans.referense_no,
            accType: trans.account_type,
            service: trans.service,
            amount: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans.amount) * 1)} />,
            paymentmethod: trans.payment_method,
            paymenttype: <div style={{ textTransform: "capitalize" }}>{trans.payment_type === "credit" ? <Tag color="green">{trans.payment_type}</Tag> : <Tag color="red">{trans.payment_type}</Tag>}</div>,
            status: <div style={{ textTransform: "capitalize" }}>{trans.status === "success" ? <Tag color="#87d068">{trans.status}</Tag> : trans.status === "cancel" ? <Tag color="#cf1322">{trans.status}</Tag> : <Tag color="#ffa500">{trans.status}</Tag>}</div>,
        }
    });
    const columns = [
        {
            title: 'Date',
            dataIndex: 'date',
        },
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Trans Ref',
            dataIndex: 'transRef',
        },
        {
            title: 'Account type',
            dataIndex: 'accType',
        },
        {
            title: 'Service',
            className: 'column-number',
            dataIndex: 'service',
            align: 'center',
        },
        {
            title: 'Amount (NGN)',
            className: 'column-number',
            dataIndex: 'amount',
            align: 'right',
        },
        {
            title: 'Payment Method',
            className: 'column-number',
            dataIndex: 'paymentmethod',
            align: 'right',
        },
        {
            title: 'Payment type',
            className: 'column-number',
            dataIndex: 'paymenttype',
            align: 'center',
        },
        {
            title: 'Status',
            className: 'column-number',
            dataIndex: 'status',
            align: 'center',
        }
    ];

    const onChangeDate = (e) => setFilterDate(e.target.value);
    const onChangeToDate = (e) => setFilterToDate(e.target.value);

    function dataFilter({ search }) {
        setQuery(search.toLowerCase())
    }

    const changeAccountType = (value) => {
        setSelectedAccountType(value)
    }

    const changePaymentType = (value) => {
        setSelectedPaymentType(value)
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" >
                                <MDTypography variant="h6" color="white">
                                    Payments
                                </MDTypography>
                            </MDBox>
                            <MDBox py={3} px={2}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div>
                                        <label>Filter Users data</label>
                                        <Form layout="vertical" form={form} initialValues={{ search: "" }} onValuesChange={dataFilter} style={{ maxWidth: 600, minWidth: 300 }}>
                                            <Form.Item name="search">
                                                <Input placeholder="search by first name" />
                                            </Form.Item>
                                        </Form>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "flex-end", gap: "10px" }}>
                                        <Select placeholder="Account Type" onChange={changeAccountType} value={selectedAccountType}>
                                            <Select.Option value="">Select Account Type</Select.Option>
                                            <Select.Option value="wallet">Wallet</Select.Option>
                                            <Select.Option value="voucher">Voucher</Select.Option>
                                        </Select>
                                        <Select placeholder="Payment Type" onChange={changePaymentType} value={selectedPaymentType}>
                                            <Select.Option value="">Select Payment Type</Select.Option>
                                            <Select.Option value="credit">Credit</Select.Option>
                                            <Select.Option value="debit">Debit</Select.Option>
                                        </Select>
                                        <div className="grid-flex" style={{ fontSize: "14px" }}>
                                            <p style={{ marginBottom: "0px", color: "rgba(0, 0, 0, 0.88)" }}>From</p>
                                            <input id="date" style={{ width: "100%", padding: "0px 11px", color: "rgba(0, 0, 0, 0.88)", height: "30px", borderRadius: "6px", border: "1px solid rgba(0, 0, 0, 0.88)" }} type="date" defaultValue={filterDate} name="date" max={moment().format('YYYY-MM-DD')} onChange={onChangeDate} />
                                        </div>
                                        <div className="grid-flex" style={{ fontSize: "14px" }}>
                                            <p style={{ marginBottom: "0px", color: "rgba(0, 0, 0, 0.88)" }}>To</p>
                                            <input id="dates" style={{ width: "100%", padding: "0px 11px", color: "rgba(0, 0, 0, 0.88)", height: "30px", borderRadius: "6px", border: "1px solid rgba(0, 0, 0, 0.88)" }} max={moment().format('YYYY-MM-DD')} type="date" defaultValue={filterToDate} name="date" onChange={onChangeToDate} />
                                        </div>
                                    </div>
                                </div>
                                <Spin tip="Loading..." spinning={spinnerLoading}>
                                    <React.Fragment>
                                        <>
                                            <div className="table-responsive">
                                                <Table columns={columns} pagination={false} dataSource={data} bordered />
                                                <div style={{ marginTop: "2%" }}></div>
                                                <Pagination showSizeChanger current={page} total={total_wallettrans} showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} transactions`} defaultPageSize={page_size} onChange={change_page} />
                                            </div>
                                        </>
                                    </React.Fragment>
                                </Spin>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout >
    );

};

export default Payments;